import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const generateOrderId = () => {
  return `ARN${Date.now().toString().slice(-8)}`;
};

export const downloadBillAsPDF = async (orderId) => {
  try {
    const element = document.getElementById('bill-content');
    if (!element) {
      alert('Bill content not found');
      return;
    }

    // Create canvas from HTML
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      windowHeight: element.scrollHeight,
      windowWidth: element.scrollWidth,
    });

    // Create PDF with A4 dimensions
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    const imgWidth = 210; // A4 width in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    // Add images to PDF (handle multiple pages if needed)
    const imgData = canvas.toDataURL('image/png');
    
    while (heightLeft >= 0) {
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= 297; // A4 height in mm
      if (heightLeft > 0) {
        pdf.addPage();
        position = -297;
      }
    }

    pdf.save(`Invoice-${orderId}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('Error generating PDF. Please try using browser print function.');
    window.print();
  }
};

export const saveBillToDatabase = async (billData) => {
  try {
    const response = await fetch('http://localhost:3001/api/bills', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(billData),
    });
    
    if (!response.ok) {
      throw new Error('Server not available');
    }
    
    return await response.json();
  } catch (error) {
    console.log('Bill not saved - server not running');
    return { message: 'Server not available' };
  }
};